import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FieldGroup } from '../../helpers/BootstrapHelpers';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import PersonListItem from './PersonListItem';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import './Home.css';
import authService from '../../services/AuthService';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';

class AssessmentSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstName: props.firstName,
            lastName: props.lastName,
            birthDate: props.birthDate,
            providerId: props.providerId,  // Provided to others and used when accessing assessments
            personList: props.personList,
            personAssessments: props.personAssessments,
            payPerUseRemaining: 999,
            payPerUseGraceQuantity: 1,
            searchMessage: props.searchMessage,
            personSortOrder: props.personSortOrder
        }
        this.addButtonDisabled = "disabled";
    }

    sortOrderHandler = (e) => {
        this.props.personSortHandler(e.target.value);
        this.state.personSortOrder = e.target.value; // Don't want a state change.
        this.componentDidMount();
    }

    valueNoSpaces = (value) => {
        return value.replace(/ /g, '');
    }

    componentDidMount = () => {
        let url = "account/" + authService.authenticatedUserId + "/persons/" + this.valueNoSpaces(this.state.personSortOrder);
        api.get(url,
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    // Response is the complete list of persons accessible by this user (including any new additions)
                    this.setState({ personList: response.data.personList, payPerUseGraceQuantity: response.data.payPerUseGraceQuantity, payPerUseRemaining: response.data.payPerUseRemaining })
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch((error) => {
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    assessmentSearchHandler = (fn, ln, bd, pId) => {
        this.props.assessmentSearchHandler(fn, ln, bd, pId);
    }

    assessmentCreationHandler = (fn, ln, bd, pId) => {
       
        this.props.assessmentCreationHandler(fn, ln, bd, pId);
    }

    firstNameChangeHandler = (e) => {
        this.setState({ firstName: e.target.value.trim() });
        this.addButtonDisabled = (this.isPersonFieldsEmptyOrNull()) ? "disabled" : "";
    }

    lastNameChangeHandler = (e) => {
        this.setState({ lastName: e.target.value.trim() });
        this.addButtonDisabled = (this.isPersonFieldsEmptyOrNull()) ? "disabled" : "";
    }

    birthDateChangeHandler = (e) => {
        this.setState({ birthDate: e.target.value.trim() });
        this.addButtonDisabled = (this.isPersonFieldsEmptyOrNull()) ? "disabled" : "";
    }

    isPersonFieldsEmptyOrNull = () => {
        var fnField = document.getElementById("firstName").value;
        var lnField = document.getElementById("lastName").value;
        var bdField = document.getElementById("birthDate").value;
        return (isNullOrEmpty(fnField) || isNullOrEmpty(lnField) || isNullOrEmpty(bdField));
    }

    personIsValid = () => {
        if (isNullOrEmpty(this.state.firstName) || isNullOrEmpty(this.state.lastName) || isNullOrEmpty(this.state.birthDate)) {
            return "Please enter first name, last name and birth date."
        }

        // Now check birth date format
        const badDateError = "Invalid birthDate format.  Please enter the birth date as mm/dd/yyyy (e.g., 01/22/2011)";
        let datePieces = this.state.birthDate.split("/");
        if (datePieces.length != 3) {
            return badDateError;
        }

        // Ensure the birthdate looks like mm/dd/yyyy - correct as necessary
        let mm = datePieces[0];
        if (mm.length <= 0 || mm.length > 2 || isNaN(mm))
        {
            return badDateError;
        }
        if (mm.length == 1) {
            mm = "0" + mm;
        }
        let mmAsInt = parseInt(mm, 10);
        if (mmAsInt < 1 || mmAsInt > 12) {
            return badDateError;
        }
        let dd = datePieces[1];
        if (dd.length <= 0 || dd.length > 2 || isNaN(dd)) {
            return badDateError;
        }

        if (dd.length == 1) {
            dd = "0" + dd;
        }
        let ddAsInt = parseInt(dd, 10);
        if (ddAsInt < 1 || ddAsInt > 31) {
            return badDateError;
        }

        let yyyy = datePieces[2];
        if (yyyy.length != 4 || isNaN(yyyy) ) {
            return badDateError;
        }

        let yyyyAsInt = parseInt(yyyy, 10);
        let thisYear = new Date().getFullYear();
        if (yyyyAsInt > thisYear || yyyyAsInt < 1920) {
            return badDateError;
        }

        let date = mm + "/" + dd + "/" + yyyy;
        this.state.birthDate = date;

        return null;
    }

    changeOwnershipHandler = () => {
        this.componentDidMount();
    }

    changeAssessmentProfileHandler = () => {
        this.componentDidMount();
    }

    personCreationHandler = () => {

        // Check for valid person formatting
        let errorMsg = this.personIsValid();
        if (errorMsg != null) {
            alertPopup('error', errorMsg);
            return;
        }

        // Create/update a person and refresh the person list
        let url = "account/createperson/" + this.valueNoSpaces(this.state.personSortOrder);
        api.post(url, {
            cadeAiUserId: authService.authenticatedUserId,
            personFirstName: this.state.firstName,
            personLastName: this.state.lastName,
            personBirthDate: this.state.birthDate,
            providerId: null    // Not using provider Id in this call!
        },
        {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                // Response is the complete list of persons accessible by this user (including any new additions)
                this.setState({ personList: response.data.personList });

                // ProviderId must be null or it will pickup the previous providerId in state (wrong!)
                this.assessmentSearchHandler(this.state.firstName, this.state.lastName, this.state.birthDate, null);
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            }
        })
        .catch((error) => {
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    createPersonToggle = (e) => {
        // Want this cleaned out for each new person
        var fnField = document.getElementById("firstName");
        var lnField = document.getElementById("lastName");
        var bdField = document.getElementById("birthDate");
        fnField.value = null;
        lnField.value = null;
        bdField.value = null;
        this.addButtonDisabled = "disabled";
    }

    render() {
        let defActiveKey = "1";
        let listTitle = null;
        let singleTitle = null;
        let childOrClient = null;
        if (this.props.isCaregiverOrRater) {
            singleTitle = "Enter Child Information";
            listTitle = null;
            defActiveKey = "0";
        }
        else if (this.props.partnerRole == 0) {
            listTitle = "Clients";
            singleTitle = "Add Client";
            childOrClient = "client";
        }
        else {
            listTitle = "Children";
            singleTitle = "Add Child";
            childOrClient = "child";
        }

        let personListItems = null;
        let personCount = 0;
        if (this.state.personList != null) {
            personListItems = this.state.personList.map((person, index) => {
                let ownerName = null;
                let canCreateAssessment = true;
                if (person.ownerName != authService.authenticatedUserId) {
                    ownerName = "Owner Id " + person.ownerName;
                    canCreateAssessment = false;
                }

                personCount = this.state.personList.length;

                return <PersonListItem
                    key={person.encodedPerson}
                    encPerson={person.encodedPerson}
                    firstName={person.personFirstName}
                    lastName={person.personLastName}
                    userDisplayName={this.props.userDisplayName}
                    birthDate={person.personBirthDate}
                    providerId={person.providerId}
                    ownerName={ownerName}
                    canCreateAssessment={canCreateAssessment}
                    payPerUseRemaining={this.state.payPerUseRemaining}
                    payPerUseGraceQuantity={this.state.payPerUseGraceQuantity}
                    assessmentCreationHandler={this.assessmentCreationHandler}
                    assessmentSearchHandler={this.assessmentSearchHandler}
                    assessmentSelectionHandler={this.props.assessmentSelectionHandler}
                    assessmentDeleteHandler={this.props.assessmentDeleteHandler}
                    assessmentCopyHandler={this.props.assessmentCopyHandler}
                    changeOwnershipHandler={this.changeOwnershipHandler}
                    changeAssessmentProfileHandler={this.changeAssessmentProfileHandler}
                    active={person.providerId == this.state.providerId}
                    personAssessments={this.props.personAssessments}
                />
            });
        }

        return (
            <Fragment>
                <Accordion className="home_accordion" defaultActiveKey={defActiveKey}>
                    <Card>
                        <Card.Header className="tour_homeAddPerson">
                            <Accordion.Toggle as={Button} variant="link" className="home_accordionText" eventKey="0" onClick={this.createPersonToggle}>
                                {singleTitle}
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="home_searchBox">
                                    <form>
                                        <FieldGroup
                                            id="firstName"
                                            type="text"
                                            label="First Name"
                                            onChange={this.firstNameChangeHandler}
                                            placeholder="First Name"
                                            defaultValue={this.state.firstName}
                                        />
                                        <FieldGroup
                                            id="lastName"
                                            type="text"
                                            label="Last Name"
                                            onChange={this.lastNameChangeHandler}
                                            placeholder="Last Name"
                                            defaultValue={this.state.lastName}
                                        />

                                        <FieldGroup
                                            id="birthDate"
                                            type="text"
                                            label="Birth Date"
                                            onChange={this.birthDateChangeHandler}
                                            placeholder="Birth Date in the form mm/dd/yyyy"
                                            defaultValue={this.state.birthDate}
                                        />

                                        {this.props.isCaregiverOrRater &&
                                            <Button variant="primary" onClick={this.assessmentSearchHandler.bind(this, this.state.firstName, this.state.lastName, this.state.birthDate, this.state.providerId)} >Find Existing Assessments</Button>
                                        }
                                        {!this.props.isCaregiverOrRater && isNullOrEmpty(this.state.providerId ) &&
                                            <Button variant="primary" onClick={this.personCreationHandler} disabled={this.addButtonDisabled} >Add to {listTitle} List</Button>
                                        }

                                        {!this.props.isCaregiverOrRater && !isNullOrEmpty(this.state.providerId) &&
                                            <Button variant="primary" onClick={this.personCreationHandler} disabled={this.addButtonDisabled}>Add to {listTitle} List</Button>
                                        }
                                        <span className='home_searchHelp'>{this.state.searchMessage}</span>
                                    </form>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header className="tour_homeExistingPerson">
                            <Form>
                                <Form.Row className="align-items-center">
                                    <Col xs="auto">
                                        <Accordion.Toggle as={Button} variant="link" eventKey="1" className="home_accordionText">
                                            {personCount} {listTitle}
                                        </Accordion.Toggle>
                                    </Col>
                                    <Col xs="auto">
                                        <h6 className="home_sortOrderLabel">Order by</h6>
                                    </Col>
                                    <Col xs="auto">
                                        <Form.Control as="select" bsPrefix="form-control home_sortOrderPulldown" size="sm" custom onChange={this.sortOrderHandler} defaultValue={this.state.personSortOrder}>
                                            <option>Last Name</option>
                                            <option>First Name</option>
                                            <option>Most Recently Modified</option>
                                        </Form.Control>
                                    </Col>
                                </Form.Row>
                            </Form>
                        </Card.Header>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <ListGroup>
                                    {personListItems}
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                
            </Fragment>
        )
    }
}

export default withRouter(AssessmentSearch);


// WEBPACK FOOTER //
// ./src/components/Home/AssessmentSearch.js